import type { IImpressionUIElement } from '@schibsted/pulse-sdk';
import type { ByfunnPulseContextInputParams } from '../../../types.js';

export interface UIElementViewAttributes {
  'data-track-event': string;
  'data-track-object-type': 'UIElement';
}

export const buildImpressionUIElementAttributes = (
  event: ByfunnPulseContextInputParams<IImpressionUIElement>,
): UIElementViewAttributes => ({
  'data-track-event': JSON.stringify(event),
  'data-track-object-type': 'UIElement',
});
